import type {AbstractStorage} from "../../services/storage/abstract-storage";
import {LocalStorageService} from "../../services/storage/local-storage";

const COMPUTER_ID_KEY = "COMPUTER_ID_KEY";
export class ComputerUuidRepository {
  constructor(private storage: AbstractStorage = new LocalStorageService()) {
  }

  public get(): string | undefined {
    const value = this.storage.getItem<string>(COMPUTER_ID_KEY);

    return value ? value.replace(/\"/g, "") : undefined;
  }

  public set(value: string): void {
    this.storage.setItem<string>(COMPUTER_ID_KEY, value);
  }

  public delete(): void {
    this.storage.removeItem(COMPUTER_ID_KEY);
  }
}

export const computerUuidRepository = new ComputerUuidRepository();
